module.exports = __webpack_public_path__ + "static/media/Logo-Color@2x.9fdd78e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/Logo-Color@2x.png
// module id = 432
// module chunks = 0